'use client';

import { c as _c } from "react/compiler-runtime";
import Slideshow from '@/app/_components/Slideshow';
import { useSlideshow } from './SlideshowContext';

/**
 * Home page slideshow wrapper that syncs current slide with context
 * for footer banner synchronization
 */
export default function HomeSlideshow(t0) {
  const $ = _c(3);
  const {
    slides
  } = t0;
  const {
    setCurrentSlide
  } = useSlideshow();
  let t1;
  if ($[0] !== setCurrentSlide || $[1] !== slides) {
    t1 = <Slideshow slides={slides} rightImageBlend={true} onSlideChange={setCurrentSlide} />;
    $[0] = setCurrentSlide;
    $[1] = slides;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}